var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentHourglass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.97859 0.366211C1.39679 0.366211 0.926758 0.836247 0.926758 1.41804C0.926758 1.99983 1.39679 2.46987 1.97859 2.46987V2.83144C1.97859 4.22511 2.53408 5.5629 3.52017 6.54899L5.74874 8.78084L3.52017 11.0127C2.53408 11.9988 1.97859 13.3366 1.97859 14.7303V15.0918C1.39679 15.0918 0.926758 15.5619 0.926758 16.1436C0.926758 16.7254 1.39679 17.1955 1.97859 17.1955H3.03042H11.4451H12.4969C13.0787 17.1955 13.5487 16.7254 13.5487 16.1436C13.5487 15.5619 13.0787 15.0918 12.4969 15.0918V14.7303C12.4969 13.3366 11.9414 11.9988 10.9553 11.0127L8.72673 8.78084L10.9586 6.54899C11.9447 5.5629 12.5002 4.22511 12.5002 2.83144V2.46987C13.082 2.46987 13.552 1.99983 13.552 1.41804C13.552 0.836247 13.082 0.366211 12.5002 0.366211H11.4451H3.03042H1.97859ZM4.08225 2.83144V2.46987H10.3932V2.83144C10.3932 3.45596 10.2092 4.06076 9.86731 4.57353H4.60816C4.2696 4.06076 4.08225 3.45596 4.08225 2.83144ZM4.60816 12.9882C4.7232 12.814 4.85797 12.6496 5.00588 12.4984L7.23773 10.2698L9.46958 12.5017C9.62078 12.6529 9.75226 12.8172 9.86731 12.9914H4.60816V12.9882Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.622,
    height: 16.8293,
    fill: "white",
    transform: "translate(0.926758 0.366211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentHourglass);
export default __webpack_public_path__ + "static/media/payment_hourglass.ca989d7952367d9af2928ea1434c4360.svg";
export { ForwardRef as ReactComponent };